import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NouvelleVersionDisponibleService } from './nouvelle-version-disponible.service';
import { Version } from './version.model';
import { estRequeteHorsCache } from '../../../utils/functions';

@Injectable({
	providedIn: 'root'
})
export class NouvelleVersionDisponibleInterceptor implements HttpInterceptor {

	constructor(private nouvelleVersionDisponibleService: NouvelleVersionDisponibleService) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(tap(evt => {
			// On ne veut pas regarder les requêtes qui récupèrent des ressources dans le cache.
			// Comme ils sont dans le cache, le sha1 et l'appVersion ne changent pas donc cela peut faire croire qu'une nouvelle version est disponible.
			if (evt instanceof HttpResponse && estRequeteHorsCache(evt.headers)) {
				const sha1 = evt.headers.get('X-App-Sha1');
				const appVersion = evt.headers.get('X-App-Version');
				const nouvelleVersion: Version = new Version(sha1, appVersion);
				this.nouvelleVersionDisponibleService.verifierVersion(nouvelleVersion);
			}
		}));
	}
}
